export interface ClubEvidenceImageRecord {
  storageKey: string;
  description: string;
}

export const isClubGeneratedOrCaseStorageKey = (value: string) =>
  /^(club\/cases\/\d+\/|club\/generated\/)/.test(String(value || "").trim());

export const isHttpAssetUrl = (value: string) => {
  const raw = String(value || "").trim();
  if (!raw) return false;
  try {
    const url = new URL(raw);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const getDisplayableAssetRefs = (values: any[]) =>
  normalizeEvidenceImageRecords(values)
    .map((value) => value.storageKey)
    .filter((value, index, array) => array.indexOf(value) === index)
    .filter((value) => isClubGeneratedOrCaseStorageKey(value) || isHttpAssetUrl(value));

export const normalizeEvidenceImageRecords = (values: any[]): ClubEvidenceImageRecord[] =>
  (Array.isArray(values) ? values : [])
    .map((value) => {
      if (typeof value === "string") {
        return {
          storageKey: String(value || "").trim(),
          description: "",
        };
      }

      return {
        storageKey: String(
          value?.storageKey ||
            value?.storage_key ||
            value?.key ||
            value?.image_storage_key ||
            value?.assetKey ||
            value?.id ||
            value?.url ||
            ""
        ).trim(),
        description: String(value?.description || value?.caption || "").trim(),
      };
    })
    .filter((value) => Boolean(value.storageKey));

export const resolveAssetAccessMap = async (
  refs: string[],
  getSignedUrl: (storageKey: string) => Promise<string>
) => {
  const entries = await Promise.all(
    refs.map(async (ref) => {
      if (isHttpAssetUrl(ref)) {
        return [ref, ref] as const;
      }

      if (!isClubGeneratedOrCaseStorageKey(ref)) {
        return [ref, ""] as const;
      }

      try {
        return [ref, await getSignedUrl(ref)] as const;
      } catch {
        return [ref, ""] as const;
      }
    })
  );

  return Object.fromEntries(entries);
};
